import * as Yup from "yup";
import { ASSETS } from "../../utils/config";
import { isSocialLinkValid } from "../../utils/socialHelpers";

export const businessBoxInitialValues = {
  business_image: "",
  name: "",
  business_title: "",
  business_email: "",
  business_url: "",
  business_link: [],
  description: "",
  advert_image: "",
  is_public: false,
};


export const businessBoxValidationSchema = Yup.object().shape({
  business_image: Yup.string().trim(),
  name: Yup.string().trim().required("Name is required"),
  business_title: Yup.string().trim(),
  business_email: Yup.string().trim(),
  // .email("Invalid email address")
  business_url: Yup.string(),
  // .url("Invalid URL")

  business_link: Yup.array().of(
    Yup.object().shape({
      platform: Yup.string().required("Platform is required"),
      link: Yup.string()
        .required("Link is required")
        .test(
          "is-valid-link-for-platform",
          "Invalid URL for the selected platform.",
          function (value) {
            const { platform } = this.parent;
            try {
              return isSocialLinkValid(value, platform);
            } catch (error) {
              return false;
            }
          }
        ),
    })
  ),

  description: Yup.string().trim(),
  advert_image: Yup.string(),
  is_public: Yup.boolean().label("Hide Box"),
});

export const socialPlatforms = [
  { name: "Website", icon: ASSETS.website, width: "12px" },
  { name: "YouTube", icon: ASSETS.youtubeIcon, width: "12px" },
  { name: "Instagram", icon: ASSETS.bb_social_instagram, width: "10px" },
  { name: "Facebook", icon: ASSETS.profileFacebook, width: "12px" },
  { name: "TikTok", icon: ASSETS.bb_social_tiktok, width: "12px" },
  { name: "X", icon: ASSETS.bb_social_twitter, width: "12px" },
  { name: "LinkedIn", icon: ASSETS.bb_social_linkedin, width: "12px" },
];


export const BBModalStyles = {
  position: "fixed",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "430px",
  minHeight: "300px",
  maxHeight: "fit-content",
  borderRadius: "20px",
  border: "1px solid #EFF4FF",
  display: "flex",
  flexDirection: "column",
  backgroundColor: "#FFF",
  padding: "24px",
  boxSizing: "border-box",
  outline: "none",

  "&:focus-visible": {
    outline: "none",
  },
};
